<template>
    <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
    <video v-lazy-load  v-if="!lazyLoad" />
    <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
    <video v-lazy-load  v-else-if="lazyLoad && intersecting" />
    <div
        v-else
        ref="miscVideoLazyPlaceholder"
        class="aspect-video flex justify-center items-center"
    >
        <div class="loading h-auto w-1/3" />
    </div>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'

withDefaults(defineProps<{
    lazyLoad?: boolean
}>(), {
    lazyLoad: true
})

const intersecting = ref(false)
const miscVideoLazyPlaceholder = ref<null | HTMLElement>(null)

// Observes as soon as the placeholder ref is filled and disconnects on unmount. The
// placeholder only renders while lazyLoad is on and nothing has intersected yet, so
// with lazyLoad off the ref stays null and no observer is ever created.
const { stop } = useIntersectionObserver(miscVideoLazyPlaceholder, ([entry]) => {
    if (entry?.isIntersecting) {
        intersecting.value = true
        stop()
    }
})
</script>
